// index.tsx
import React from 'react';
import WelcomePage from 'components/WelcomePage';
// import {Parallax, ParallaxLayer} from '@react-spring/parallax';


const Home: React.FC = () => {
    return (
        <div>
            <WelcomePage />
        </div>
    );
};

export default Home;

